/**
 * How many of the four bars a round trip lights, and in which colour. The
 * steps follow what a click feels like here: under 80 ms a step lands at
 * once, past 250 ms the walk visibly lags behind the click.
 */
export const PING_BARS = 4;

export type PingQuality = 'good' | 'fair' | 'poor' | 'bad' | 'lost';

export function pingQuality(ms: number | undefined): PingQuality {
  if (ms === undefined) return 'lost';
  if (ms < 80) return 'good';
  if (ms < 150) return 'fair';
  if (ms < 250) return 'poor';
  return 'bad';
}

export function pingBars(quality: PingQuality): number {
  switch (quality) {
    case 'good':
      return 4;
    case 'fair':
      return 3;
    case 'poor':
      return 2;
    case 'bad':
      return 1;
    case 'lost':
      return 0;
  }
}
